<template>
  <div class="sa-card-large">
    <div class="sa-mob-header sa-header1">
      <button class="sa-btn-back sa-h-sm-up" @click="$router.go(-1)">
        <i class="icon-left-arrow"></i>
      </button>
      <h5 class="sa-card-tit">Notifications</h5>
    </div>
    <img
        src="../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader"
        v-if="loader"
      />   
    <div class="sa-mob-cont" v-else-if="notifications && notifications.length">
      <ul class="sa-notific-list">
        <li
          @click="redirectNotification(item)"
          v-for="(item, index) in notifications"
          :key="index"
          :style="{ 'background-color': item.color }"
        >
          <small class="sa-noti-tim">{{ getTime(item.time) }}</small>
          <strong>{{ item.title }}</strong>
          <span class="sa-noti-desc">{{ item.message }}</span>
        </li>
      </ul>
      <infinite-loading
        :identifier="infiniteId"
        @infinite="notificHandler"
        spinner="waveDots"
      ></infinite-loading>
    </div>
    <div class="sa-no-data" v-else>
      <img
        src="../../assets/img/page-not-found.svg"
        alt="Page not Found"
        class="sa-img-responsive"
      />
      <h6>Sorry! you don't have any notifications message</h6>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { oh_url } from "../../../config/endpoints";
import moment from "moment";
export default {
    computed: {
        notifications: function () {
            return this.$store.getters.getNotifications
        }
    },
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      page: 1,
      limit: 10,
      infiniteId: +new Date(),
      notification: [],
      loader: false
    };
  },
  methods: {
    redirectNotification: function (obj) {
      let _self = this;
      if (obj && obj.uc_id && obj.payload && obj.payload.status) {
        if (obj.payload.status == "4") {
          this.$router.push(
            `/appointments/doctor-details/review-diagnosis/${obj.payload.apnt_id}`
          );
        } else {
          console.log(this.utid,'uti');
          if(this.utid == (4 || 3)){
            console.log(this.utid,'uid');
            this.$router.push(`/new-booking-details?apnt_id=${obj.payload.apnt_id}&is_multi_patient=true`)
          }else{
            this.$router.push(`/appointments/doctor-details/${obj.payload.apnt_id}`);
          }
        }
      } else if (obj.uc_id) {
        switch (obj.uc_id) {
          case "UCD4": 
          case "UCD5": {
            _self.$router.push(
            '/profile'
          );
          }
        }
      }
      if (obj.tid) {
        _self.$store
          .dispatch("httpPost", {
            uri: `${oh_url}/pro/notification/updateStatus`,
            body: {
              tid: obj.tid,
            },
          }).then(function(res){
              if (res && res.status === 1000) {
                let count = _self.$store.getters.getNotificationCount
                let updateCount = count && count - 1
                _self.$store.dispatch('SET_NOTIFICATION_COUNT', (updateCount >= 0) ? updateCount : 0)
              }
          })
      }
    },
    getTime: function (time) {
      return (time && moment(time).fromNow()) || "";
    },
    notificHandler($state) {
      let _self = this;
      let data = {
        page: _self.page,
        page_limit: _self.limit,
      };
      _self.$store
        .dispatch("httpGet", {
          uri: `${oh_url}/pro/notification/list?page=${data.page}`,
          body: data,
        })
        .then((response) => {
          _self.loader = false
          if (response && response.status === 1000) {
            if (
              response.data &&
              response.data.notification &&
              response.data.notification.length
            ) {
              _self.page += 1;
              let notifications = JSON.parse(JSON.stringify(_self.$store.getters.getNotifications))
              notifications.push(...response.data.notification);
              _self.$store.dispatch('SET_NOTIFICATIONS', notifications)
              if ($state)
              $state.loaded();
            } else {
              if($state)
              $state.complete();
            }
          }
        });
    },
  },
  mounted() {
    this.utid = JSON.parse(this.$localStorage.get("utid"))
    this.$store.dispatch('SET_NOTIFICATIONS', [])
    this.loader = true
    this.notificHandler();
  },
};
</script>
